import script from "./Product.vue?vue&type=script&setup=true&lang=js"
export * from "./Product.vue?vue&type=script&setup=true&lang=js"

import "./Product.vue?vue&type=style&index=0&id=270c1be7&scoped=true&lang=css"

import exportComponent from "D:\\20231109nkGg7QhS(1)\\20231109nkGg7QhS\\vueweb\\vue-antd-tool-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-270c1be7"]])

export default __exports__